import isApiError from "@insite/client-framework/Common/isApiError";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

export interface QuoteRequestModel {
    firstName: string;
    lastName: string;
    phoneNumber: string;
    emailAddres: string;
    message?: string;
    companyName: string;
    productName: string;
    productSku: string;
    location: string;
    quantity: number;
    emailTo: string;
    topic: string;
    uom: string;
}

type GuestQuoteRequestFormParameter = {
    quoteRequestModel: QuoteRequestModel;
} & HasOnSuccess & HasOnError;

interface GuestQuoteRequestFormApiParameter extends ApiParameter {
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    emailAddress?: string;
    message?: string;
    companyName?: string;
    productName?: string;
    productSku?: string;
    location?: string;
    quantity?: number;
    emailTo?: string;
    topic?: string;
    unitOfMeasure?: string;
    consent?: boolean;
}

type HandlerType = ApiHandlerDiscreteParameter<GuestQuoteRequestFormParameter, GuestQuoteRequestFormApiParameter>;

const emailsUrlExtension = "/api/v1/emailExtensions";

export function ucsRequestQuoteForm(parameter: GuestQuoteRequestFormApiParameter) {
    return post<GuestQuoteRequestFormApiParameter, void>(`${emailsUrlExtension}/guestRfq`, parameter);
}

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        firstName: props.parameter.quoteRequestModel.firstName,
        lastName: props.parameter.quoteRequestModel.lastName,
        message: props.parameter.quoteRequestModel.message,
        phoneNumber: props.parameter.quoteRequestModel.phoneNumber,
        emailAddress: props.parameter.quoteRequestModel.emailAddres,
        companyName: props.parameter.quoteRequestModel.companyName,
        productName: props.parameter.quoteRequestModel.productName,
        productSku: props.parameter.quoteRequestModel.productSku,
        location: props.parameter.quoteRequestModel.location,
        quantity: props.parameter.quoteRequestModel.quantity,
        emailTo: props.parameter.quoteRequestModel.emailTo,
        topic: props.parameter.quoteRequestModel.topic,
        unitOfMeasure: props.parameter.quoteRequestModel.uom,
        consent: false,
    };
};

export const SendDataToApi: HandlerType = async props => {
    try {
        await ucsRequestQuoteForm(props.apiParameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.();
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const ucsGuestQuoteRequest = createHandlerChainRunner(chain, "ucsGuestQuoteRequest");
export default ucsGuestQuoteRequest;
